import React from 'react'
import './SuccessMessage.css'

const SuccessMessageUI = ({successMsg, className}) =>
  <React.Fragment>
    {
      successMsg &&
      <div className={`w_success_msg ${className ? className : ''}`}>
        {successMsg}
      </div>
    }
  </React.Fragment>

export default SuccessMessageUI
